.k7{bottom:0.25rem;}